// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + "0205b5da21a1a7db3950" + "-11.13.3-3862c46-202505020648.js";
};